import { inject } from '@angular/core';
import {
  callApiMethod,
  setError,
  setLoaded,
  setLoading,
  withModelRestore,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import {
  IMapBounds,
  IMapItem,
} from '@kinet-open-network/shared/data-access/model';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { DeliveriesService } from '../services/deliveries.service';

export const flowKey = (flow: { type: string; id: string | number }) =>
  `${flow.type}_${flow.id}`;

export const DeliveriesStore = signalStore(
  { protectedState: false },
  withResourceState(DeliveriesService),
  withModelRestore(DeliveriesService),
  withState<{
    flowMapItems: { type: string; items: IMapItem[] }[];
    initialFlows: Set<string>;
    bounds: IMapBounds | undefined;
  }>({
    flowMapItems: [] as { type: string; items: IMapItem[] }[],
    initialFlows: new Set<string>(),
    bounds: undefined,
  }),
  withMethods((store, service = inject(DeliveriesService)) => ({
    loadFlows: (deliveryId: string) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.getFlows(deliveryId), {
        next: (flows) => {
          store.patchModel({
            flows: flows.data.sort(
              (a, b) => (a.deliveryOrder || 0) - (b.deliveryOrder || 0),
            ),
          });
          patchState(store, setLoaded());
        },
        error: (err) => patchState(store, setError(err)),
      });
    },
    loadMapItems: (bounds: IMapBounds) => {
      patchState(store, setLoading());
      return callApiMethod(() => service.getMapItems(bounds), {
        next: (result) => {
          patchState(store, { flowMapItems: result.data, bounds }, setLoaded());
        },
        error: (err) => patchState(store, setError(err)),
      });
    },
    setInitialFlows: (flows: { type: string; id: string | number }[]) => {
      const initialFlows = new Set(flows.map(flowKey));
      patchState(store, { initialFlows });
    },
  })),
);
